let cn = {
    LOGIN: "登录",
    LOGIN_TITLE: "仲量联行投标平台",
    PHONELOGIN: "手机登录",
    ACCLOGIN: "账号登录",
    FORGOTPASS: "忘记密码 ?",
    LOGGINING: "正 在 登 录 ...",
    LOG_IN: "登  录",
    NOACC: "还没有账号",
    PLEASEINPUTPHONE: "请输入手机号",
    PLEASEINPUTACC: "请输入用户账号",
    PLEASEINPUTPASS: "请输入密码",
    PLEASEINPUTCODE: "请输入验证码",
    ACCOUNTNAME: "用户账号",
    PASSWORD: "密码",
    VERCODE: "邮箱验证码",
    SEND_VERCODE: "发送验证码",
    SENDING: "正在发送",
    RESEND: "秒后重新获取",
};
let tw = {
    LOGIN: "登錄",
    LOGIN_TITLE: "仲量聯行招投標平臺",
    PHONELOGIN: "手機登錄",
    ACCLOGIN: "賬號登錄",
    FORGOTPASS: "忘記密碼 ?",
    LOGGINING: "正 在 登 錄 ...",
    LOG_IN: "登 錄",
    NOACC: "還沒有賬號",
    PLEASEINPUTPHONE: "請輸入手機號",
    PLEASEINPUTACC: "請輸入用戶賬號",
    PLEASEINPUTPASS: "請輸入密碼",
    PLEASEINPUTCODE: "請輸入驗證碼",
    ACCOUNTNAME: "用戶賬號",
    PASSWORD: "密碼",
    VERCODE: "郵箱驗證碼",
    SEND_VERCODE: "發送驗證碼",
    SENDING: "正在發送",
    RESEND: "秒後重新獲取",
};
let en = {
    LOGIN: "Login",
    LOGIN_TITLE: "JLL Tendering Platform",
    PHONELOGIN: "Mobile Login",
    ACCLOGIN: "Account Login",
    FORGOTPASS: "Forgot Password ?",
    LOGGINING: "Signing In ...",
    LOG_IN: "Login",
    NOACC: "No Account Yet",
    PLEASEINPUTPHONE: "Please enter cell phone number",
    PLEASEINPUTACC: "Please enter your username",
    PLEASEINPUTPASS: "Please enter your password",
    PLEASEINPUTCODE: "Please enter your verification code",
    ACCOUNTNAME: "Username",
    PASSWORD: "Password",
    VERCODE: "Email Verification Code",
    SEND_VERCODE: "Send Verification Code",
    SENDING: "Sending ...",
    RESEND: "Seconds",
}

export {
    cn,
    tw,
    en
}